import {
		dateIsToday, 
		calculateTrackerProgress,
		calculateCircleDegreeFromPercentage
} from '../global/utils';


export class WorkoutProgress {
	constructor(
		daysDone=-1,
		durationDays=-1,
		lastUpdated=-1,
	) {
		this.daysDone = daysDone;
		this.durationDays = durationDays;
		this.goal = this.durationDays;
		this.lastUpdated = lastUpdated;
		this.doneToday = this.calculateDoneToday();
		this.percentage = 0.0;
		this.circlePercentage = 0.0;
		this.currentDay = this.daysDone + 1;
		this.degree = 0.0;
		this.complete = false;

		this.calculateProgressPercentage();
	}

	getDaysDone() {
		return this.daysDone;
	}

	getGoal() {
		return this.goal;
	}

	getDoneToday() {
		return this.doneToday;
	}

	getComplete() {
		return this.complete;
	}

	calculateProgressPercentage() {		
		const progress = calculateTrackerProgress(this.daysDone, this.goal);

		if ( progress.circlePercentage ) {
			this.circlePercentage = progress.circlePercentage;
		}

		if ( progress.percentage ) {
			this.percentage = Math.ceil(progress.percentage);
			this.degree = calculateCircleDegreeFromPercentage(this.percentage);
		}
		
		this.calculateComplete();

		return progress;
	}

	calculateDoneToday() {
		return dateIsToday( new Date(this.lastUpdated) );
	}

	calculateComplete() {
		this.complete = this.percentage >= 100;
	}
}